<template>
    <ViewBase class="view-marketplace-list">

        <MarketList @open="handleOpen" />
        <CellSpace />

    </ViewBase>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { ViewBase } from '@generio-ai/library-legacy/components/views'
import { MarketList } from '@generio-ai/library-legacy/components/market'
import { CellSpace } from '@generio-ai/library-legacy/components/cells'
    
export default {
    name: 'ViewMarketRoot',
    components: {
        ViewBase,
        MarketList,
        CellSpace
    },
    computed: {
        ...mapGetters('market', [
            'isSynchronized'
        ])
    },
    watch: {
        isSynchronized(newValue, oldValue) {
            if (newValue === oldValue) return
            if (newValue) this.hide()
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('market', [
            'synchronize'
        ]),
        ...mapActions('overlay', [
            'show',
			'hide'
		]),
        init() {
            if (this.isSynchronized) {
                this.hide()
                return
            }
            this.synchronize()
            this.show({
                message: 'synchronizing market'
            })
        },
        handleOpen(asset) 
        {
            this.$router.push(`/market/${asset?.id}`)
        }
    },
    mounted() {
        this.init()
    }
}
</script>